'use client';

import React from 'react';
import styled from 'styled-components';
import { useDensity } from '@liftango/ui-tokens';

const Bar = styled.div<{ $py: string; $px: string; $gap: string }>`
  display: flex;
  align-items: center;
  gap: ${(p) => p.$gap};
  padding: ${(p) => p.$py} ${(p) => p.$px};
  background: ${(p) => p.theme.colors.neutral.panel};
  border-bottom: 1px solid ${(p) => p.theme.colors.neutral.line};
  flex-wrap: wrap;
`;

export function Toolbar({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const density = useDensity();
  return (
    <Bar
      role="toolbar"
      className={className}
      $py={density.paddingY}
      $px={density.paddingX}
      $gap={density.gap}
    >
      {children}
    </Bar>
  );
}

export const ToolbarGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.spaceAlias.xs};
`;

const DividerBase = styled.div`
  width: 1px;
  height: 22px;
  background: ${(p) => p.theme.colors.neutral.line};
  flex-shrink: 0;
`;

export function ToolbarDivider() {
  return <DividerBase data-divider="" />;
}

export const ToolbarSpacer = styled.div`
  flex: 1;
`;
